<div mat-dialog-header>
  <h1>{{ headline }}</h1>
</div>
<mat-dialog-content #scroll class="dialog-container">
  <form>
    <mat-form-field class="col-6" [ngClass]="{ 'col-12': data.app === 'cp' }">
      <input
        matInput
        name="text"
        [placeholder]="placeholder"
        [(ngModel)]="reportOptions.filename"
      />
    </mat-form-field>
    @if (data.app !== 'cp') {
      <mat-form-field class="col-6">
        <input
          matInput
          name="number"
          placeholder="Minimum Bridge Score"
          [(ngModel)]="reportOptions.threshold"
        />
      </mat-form-field>
    }
    <mat-checkbox
      name="annReview"
      class="col-6"
      [(ngModel)]="reportOptions.annReview"
    >
      Include Annual Review
    </mat-checkbox>
    <mat-checkbox
      name="needSummary"
      class="col-6"
      [(ngModel)]="reportOptions.needSummary"
    >
      Include Needs Summary
    </mat-checkbox>
    <mat-checkbox
      name="needDetail"
      class="col-6"
      [(ngModel)]="reportOptions.needDetail"
    >
      Include Needs Detail
    </mat-checkbox>
    @if (data.app === 'cp') {
      <mat-checkbox
        name="prodSummary"
        class="col-6"
        [(ngModel)]="reportOptions.prodSummary"
      >
        Include Product Summary
      </mat-checkbox>
    }
    @if (data.app === 'cp') {
      <mat-checkbox
        name="prodDetail"
        class="col-6"
        [(ngModel)]="reportOptions.prodDetail"
      >
        Include Product Details
      </mat-checkbox>
    }
    <mat-checkbox name="specific" class="col-6" [(ngModel)]="specific">
      Include Specific Suggestions
    </mat-checkbox>
    @if (data.needs && data.needs.length && specific) {
      <h4>Needs to Include</h4>
    }
    @if (specific) {
      @for (nd of data.needs; track nd) {
        <mat-checkbox
          name="{{ nd.name }}"
          class="col-6"
          [(ngModel)]="selectedBridges[nd.name]"
        >
          {{ nd.ShortName }}
        </mat-checkbox>
      }
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions class="row buttons">
  <button mat-raised-button color="accent" (click)="save()">
    {{ confirm }}
  </button>
  <button mat-raised-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
